import React from 'react';
import { motion } from 'framer-motion';
import type { SlideProps } from './SlideShell';
export function Slide01Title({
  index
}: SlideProps) {
  return <div className="relative w-full h-full overflow-hidden bg-white" data-id="element-78" data-mp="1eydizxe69xp6">
      {/* Hero image */}
      <div className="absolute inset-0" data-id="element-79" data-mp="102xhj7b9izir">
        <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/91219c59-3b06-4353-b2d2-2ca5926bfb97.jpg" alt="" role="presentation" className="w-full h-full object-cover opacity-70" initial={{
        scale: 1.05
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} data-id="element-80" data-mp="151qzbbxl1coq" />
        <div className="absolute inset-0 bg-white/55" data-id="element-81" data-mp="mc2be2s5ewiv" />
      </div>

      {/* Top accent */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      delay: 0.1,
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-0 left-0 right-0 h-2 bg-[var(--brand)] origin-left z-20" data-id="element-82" data-mp="8ct2zpa6p6pg" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-83" data-mp="2eh75yiauabg4">
        <div className="max-w-4xl" data-id="element-84" data-mp="29icbgj3ieyg6">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.6
        }} className="flex items-center gap-4 mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-85" data-mp="1lr6vm3xkk65v">
            <span className="h-px w-12 bg-[var(--brand)]" data-id="element-86" data-mp="130yzw6w78hzp" />
            <p className="text-[var(--brand)] text-[clamp(0.85rem,1.3vw,1.1rem)] font-bold uppercase tracking-[0.25em]" data-id="element-87" data-mp="12ze4kf228v0s">
              Proposal
            </p>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} className="text-[var(--fg)] font-extrabold text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.02] tracking-[-0.04em] mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-88" data-mp="1noqh4e2jg2sn">
            Continued Brand Campaigns —
            <br data-id="element-89" data-mp="18vd80eo979u4" />
            <span className="text-[var(--brand)]" data-id="element-90" data-mp="1dsdeursxggma">Snakker</span>
            <br data-id="element-91" data-mp="1dqslv6m9h5qj" />
            Campaign Partnership
          </motion.h1>

          {/* Subline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.6
        }} className="max-w-3xl mb-[clamp(2rem,4vw,3rem)]" data-id="element-92" data-mp="1it1bbszxdpnw">
            <span className="block text-[var(--fg)] text-[clamp(1.1rem,1.8vw,1.6rem)] font-bold leading-snug" data-id="element-93" data-mp="djni4fbnrr7v">
              A scalable model for giving more brands more attention, more often.
            </span>
            <span className="mt-3 block text-[var(--muted)] text-[clamp(0.9rem,1.25vw,1.15rem)] font-medium leading-relaxed" data-id="element-94" data-mp="3tcbgl0lb3xa">
              Interactive HCP campaigns built from reusable master assets —
              created, executed and continuously optimized across brands,
              countries and channels.
            </span>
          </motion.p>
        </div>
      </div>

      {/* Footer row */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 flex items-center justify-end gap-4" data-id="element-95" data-mp="3h1yvjkenlhou">
        <span className="px-4 py-1.5 bg-[var(--brand)] text-white text-xs font-bold rounded-full uppercase tracking-wider shadow-sm" data-id="element-96" data-mp="1s91o1yt2wdw9">
          Campaign Partnership
        </span>
        <span className="px-4 py-1.5 bg-white border border-black/10 text-[var(--fg)] text-xs font-bold rounded-full uppercase tracking-wider shadow-sm" data-id="element-97" data-mp="1def3h2iudllp">
          Illustrative brand
        </span>
      </motion.div>
    </div>;
}